export default __webpack_public_path__ + "static/media/bolt.fd0c9580.png";